import { render, staticRenderFns } from "./text.vue?vue&type=template&id=1106a88c&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1106a88c')) {
      api.createRecord('1106a88c', component.options)
    } else {
      api.reload('1106a88c', component.options)
    }
    module.hot.accept("./text.vue?vue&type=template&id=1106a88c&", function () {
      api.rerender('1106a88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/text.vue"
export default component.exports